import { useSearchParams, useNavigate } from 'react-router-dom';

/*
  Use Case:
  When opening one popup over another, both rendered via navigation, it may be necessary to add or remove 
  additional query parameters in the URL before navigating to the new query param path.

  Example Usage:
  To remove specific parameters (e.g., `proId`, `seq`, `isPickupPro`) from the URL while preserving state:
*/

const useUpdateOrRemoveQueryParams = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const updateOrRemoveQueryParams = ({ paramsToUpdate, shouldRemove = false, stateData = {} }) => {
    let updated = false;
    Object.entries(paramsToUpdate).forEach(([key, value]) => {
      if (shouldRemove) {
        if (searchParams.has(key)) {
          searchParams.delete(key);
          updated = true;
        }
      } else {
        if (value !== undefined && value !== null) {
          searchParams.set(key, value);
          updated = true;
        }
      }
    });
    if (updated) {
      navigate(`?${searchParams.toString()}`, { state: stateData, replace: true });
    }
  };
  return updateOrRemoveQueryParams;
};

export default useUpdateOrRemoveQueryParams;
